import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

@Injectable()
export class SlServicesService {

    constructor(
        private fns: AngularFireFunctions,
    ) {
        if (window.location.href.includes('127.0.0.1') || window.location.href.includes('localhost')) {
            console.log('using local backend');
            fns.useFunctionsEmulator('http://localhost:5001');
        }
    }

    public async callService(path: string, data: any = {}) {
        // Set timeout to 2 minutes (120000 ms)
        const callable = this.fns.httpsCallable(path, { timeout: 120000 });
        return callable(data).toPromise();
    }
}
